import RenderRichText from '../RenderRichText';

import { Props } from './types';

const NoteBody = ({ note }: Props) => {
  const { body } = note;

  return (
    <div className="mp-sensitive">
      <RenderRichText body={body} />
    </div>
  );
};

export default NoteBody;
